import { isAction, Middleware } from "@reduxjs/toolkit";
import { setFragments } from ".";
import { RootState } from "..";
import { CustomNotifyType } from "../../components/Modal/ModalNotify/Custom/CustomNotifyRouter";
import { addCustomNotify } from "../notifications";

export const fragmentsMiddleware: Middleware<{}, RootState> = 
    (store) => (next) => (action) => {
        if (isAction(action) && action.type === setFragments.type) {
            const previousFragments = store.getState().draws.fragments;
            if ('payload' in action && typeof action.payload === 'number') {
                const newFragments = action.payload;
                if (previousFragments > 0 && newFragments > 0) {
                    store.dispatch(addCustomNotify(CustomNotifyType.NewFragment));
                }
            }
        }
        
        return next(action);
    };